import { render, staticRenderFns } from "./PageNotAllowed.vue?vue&type=template&id=8aeccb74&scoped=true&"
import script from "./PageNotAllowed.vue?vue&type=script&lang=js&"
export * from "./PageNotAllowed.vue?vue&type=script&lang=js&"
import style0 from "./PageNotAllowed.vue?vue&type=style&index=0&id=8aeccb74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aeccb74",
  null
  
)

export default component.exports